import axios from 'axios';
import { sessionEvents } from '../contexts/AuthContext';

// Create an axios instance with the base URL from environment variables
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

// Add a request interceptor to handle authentication
apiClient.interceptors.request.use(
  (config) => {
    // Get the token from localStorage
    const token = localStorage.getItem('token');

    // If token exists, add it to the Authorization header
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 403 errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if the error is a 403 with SESSION_EXPIRED code
    if (error.response && error.response.status === 403 && 
        error.response.data && error.response.data.code === 'SESSION_EXPIRED') {
      // Trigger session expired event
      sessionEvents.onSessionExpired();

      // Show a user-friendly message
      error.message = 'Your session has expired. Please log in again.';
    }

    return Promise.reject(error);
  }
);

export default apiClient;
